import { Injectable } from '@angular/core';
import { Buffer } from 'buffer';
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class ApiHeadersService {
  private deviceId: string;

  constructor(private deviceDetectorService: DeviceDetectorService) {
    const isCignaTraceEnabled = sessionStorage.getItem('isCignaTraceEnabled');
    if (isCignaTraceEnabled) {
      this.deviceId = this.getOrCreateDeviceId();
    }
  }

  /**
   * Generates custom headers for API requests
   * Note: This generates a new service reference ID and timestamp each time it's called
   */
  generateApiHeaders() {
    return {
      'x-cigna-trace-id': Buffer.from(
        `${this.deviceId}#${format(new Date(), 'yyyy-MM-dd')}`,
      ).toString('base64'),
      'x-service-reference-id': uuidv4(),
    };
  }

  private getOrCreateDeviceId(): string {
    const storedId = sessionStorage.getItem('cigna-device-id');
    if (storedId) {
      return storedId;
    }

    const deviceInfo = this.deviceDetectorService.getDeviceInfo();
    const newId = `${deviceInfo.deviceType}-${uuidv4()}`;
    sessionStorage.setItem('cigna-device-id', newId);
    return newId;
  }
}
